module.exports = __webpack_public_path__ + "img/icon-nav7.780e2eae.svg";